/* tslint:disable */
/* eslint-disable */
/**
 * External EMR API
 * Clinical documents pulled from external EMRs (Net Health today) for a patient\'s external EHR record. Consumer-agnostic: concurrent review is the first consumer, but nothing here is re-auth specific. Routes are lead-scoped because the pull needs the lead\'s facility to resolve the Net Health credentials and consumer site; the documents themselves belong to the external EHR patient.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExternalEmrDocumentPullStart
 */
export interface ExternalEmrDocumentPullStart {
    /**
     * False when a pull was already running for this patient
     * @type {boolean}
     * @memberof ExternalEmrDocumentPullStart
     */
    is_started: boolean;
}

/**
 * Check if a given object implements the ExternalEmrDocumentPullStart interface.
 */
export function instanceOfExternalEmrDocumentPullStart(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_started" in value;

    return isInstance;
}

export function ExternalEmrDocumentPullStartFromJSON(json: any): ExternalEmrDocumentPullStart {
    return ExternalEmrDocumentPullStartFromJSONTyped(json, false);
}

export function ExternalEmrDocumentPullStartFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEmrDocumentPullStart {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_started': json['is_started'],
    };
}

export function ExternalEmrDocumentPullStartToJSON(value?: ExternalEmrDocumentPullStart | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_started': value.is_started,
    };
}

